var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "c-checklist-media-block__container" },
    [
      _c("div", { staticClass: "c-checklist-media-block__guide-box" }, [
        _c(
          "div",
          { ref: "mkbBo", staticClass: "c-checklist-media-block__mkb-bo" },
          [
            _vm._t("default", [_c("VChecklistPopupModal")]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: "/gui/images/checklist-items/mkb-bo-cyckel.svg",
                alt: "bo på cyckel",
                "aria-hidden": "true"
              }
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-checklist-media-block__background" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { ref: "road", staticClass: "c-checklist-media-block__road" },
          [
            _c("img", {
              style: _vm.getRoadImageStyle,
              attrs: {
                src: "/gui/images/checklist-items/mkb-dash-linje.svg",
                alt: "linje",
                "aria-hidden": "true"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "end", staticClass: "c-checklist-media-block__end" }, [
          _c("img", {
            attrs: {
              src: "/gui/images/checklist-items/mkb-hus.svg",
              alt: "hus",
              "aria-hidden": "true"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-checklist-media-block__start" }, [
      _c("img", {
        attrs: {
          src: "/gui/images/checklist-items/mkb-flyttboxar.svg",
          alt: "flyttboxar",
          "aria-hidden": "true"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }